import { Navigate } from "react-router-dom";

export function Settings() {
  // Redirect to account settings as default
  return <Navigate to="/settings/account" replace />;
}

